window.addEventListener('DOMContentLoaded', () => {
  let data = document.querySelectorAll('.zodiac-sign');

  data.forEach((i) => {
    i.addEventListener("click", () => {
      let getAttr = i.getAttribute("data-sign");
      let commonElements = document.querySelectorAll('.common');

      commonElements.forEach((element) => {
        if (element.id === getAttr) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });
});
